// extracted by mini-css-extract-plugin
export default {"table-container":"components-settings-users-modals-modal-subscription-access-module__table-container"};